import React, {Component} from 'react';
import PropTypes from "prop-types";
import DatePicker from 'react-datepicker';
import * as moment from "moment";

const propTypes = {
	value: PropTypes.string,
	disabled: PropTypes.bool,
	className: PropTypes.string,
	name: PropTypes.string,
	id: PropTypes.string
}

const defaultProps = {
	disabled: false,
	value: undefined,
}

class DateTimePick extends Component {
	render() {
		return <DatePicker
			name={this.props.name}
			id={this.props.id}
			selected={this.props.value ? moment(this.props.value) : undefined}
			onChange={(value) => this.props.onChange(value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : "")}
			placeholderText={moment().format('YYYY-MM-DD HH:mm:ss')}
			className={this.props.className}
			disabled={this.props.disabled}
			value={this.props.value ? this.props.value : ""}
			showTimeSelect
			timeFormat="HH:mm:ss"
			injectTimes={[
				moment().hours(23).minutes(59).seconds(59)
			]}
			timeIntervals={15}
			timeCaption="Hora"
			dateFormat="YYYY-MM-DD HH:mm:ss"
			isClearable={true}
		/>
	}
}

DateTimePick.propTypes = propTypes;
DateTimePick.defaultPros = defaultProps;

export default DateTimePick;




// WEBPACK FOOTER //
// ./src/elements/forms/datetimepicker.jsx